// Capture the current dashboard view as a PNG File to attach.
// html2canvas is imported lazily so it stays out of the main bundle.
export const captureScreenshot = async (): Promise<File | null> => {
  // Called from a click handler — html2canvas can fail (lazy-import error,
  // tainted/CORS canvas, render error), so never let it throw to the UI.
  try {
    const html2canvas = (await import('html2canvas')).default;

    // Capture the whole viewport via <html>, NOT `.app-main`: the reservation
    // and calendar screens are `position: fixed`, so `.app-main` has no height
    // and capturing it yields an empty sliver. Crop the width to exclude the
    // open support panel (its width is the `--support-inset` CSS variable) and
    // ignore the panel element itself as a belt-and-suspenders.
    const inset =
      parseInt(
        getComputedStyle(document.body).getPropertyValue('--support-inset'),
        10,
      ) || 0;

    const canvas = await html2canvas(document.documentElement, {
      useCORS: true,
      logging: false,
      backgroundColor: null,
      scale: 1,
      x: window.scrollX,
      y: window.scrollY,
      width: Math.max(1, window.innerWidth - inset),
      height: window.innerHeight,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      ignoreElements: (el) =>
        el instanceof HTMLElement && el.classList.contains('support-panel'),
    });

    return await new Promise((resolve) => {
      canvas.toBlob(
        (blob) =>
          resolve(
            blob
              ? new File([blob], `screenshot-${Date.now()}.png`, {
                  type: 'image/png',
                })
              : null,
          ),
        'image/png',
      );
    });
  } catch {
    return null;
  }
};
